/**
 * Ticket Priority Options
 * Defines the available priority levels for tickets
 */
export const TICKET_PRIORITY_OPTIONS = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Urgent", value: "urgent" },
  { label: "Critical", value: "critical" },
];
